import React, { useEffect, useState } from 'react'
import Button from '../../common/Button';
import { useNavigate, useLocation, useOutletContext } from "react-router-dom";
import ImModuleStyle from '../styles/im.module.css';
import { get_settings, save_settings } from '../services/api';

const Settings = () => {
  const [settings,setSettings] = useState({})
  const [isLevelSet,setisLevelSet] = useState(false)
  const [levelSelected,setLevelSelected] = useState("")
  const [isLevelUpdated, setIsLevelUpdated] = useState(false)
  const [isLeaderboardUpdated, setIsLeaderboardUpdated] = useState(false)
  const [isSaveDisable, setIsSaveDisable] = useState(true);
  const [
    simPopup,
    setSimPopup,
    isOverlay,
    setIsOverlay,
    headerPopup,
    setHeaderPopup,
    isArtifacts,
    setIsArtifacts,
    plPopup,
    setPlPopup,
    ulPopup,
    setUlPopup,
    simPrgPopup,
    setSimPrgPopup,
    skipWalkThruPopups,
    isPopupShown,
    setIsPopupShown,
    accordionPopup,
    setAccordionPopup,
    simObj,
    setSimObj,
    getMonth,
    toggleSimulation,
    setToggleSimulation,
    startOverSimulation,
    isLoader,
    setIsLoader,
    setAriaProperty,
    check_Location,
    setError,
    error,
    simType,
    qmPopup,
    setQmPopup,
    setRelaunchPopup,
  ] = useOutletContext();
  const settingStyle = {
    "margin": "30px auto",
    // "width": "80%",
    "marginTop": "30px;"
  }
  const closeWindow = (e) => {
    window.close();
  }
  const formatNum = (num) => {
    return num?.toLocaleString('en-US', { style: 'decimal' });
  }
  const saveSettings = ()=> {
    // selectedOption = 
    save_settings({"level":"EASY"})
  }
  const cancelSettings = () => {

  }
  // useEffect(() => {
    
  //   return () => {
  //   };
  // }, [])
  useEffect(() => {
    window.$('.ui.selection.dropdown.cust1')
      .dropdown({ clearable: true, placeholder: 'any' });
      window.$(".ui.checkbox").checkbox();
      if(!(window.$(".ui.checkbox").hasClass("checked"))){
        window.$(".ui.checkbox").click();
      }
    document.title = "Inventory Management | Settings";
    document.querySelector("header.header .artifacts").style.display = "none";
    document.querySelector(".App .row").style.minHeight = "auto";
    document.querySelector(".App .row").style.minHeight = "100vh";
    setIsOverlay(false)
    // get_settings();
    setTimeout(()=>{
      if(settings != {}){
      get_settings().then((response) => {
        if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
          setError(response?.data)
}
else{
        if (typeof response != 'undefined') {
          setSettings(response?.data);
          setIsLoader(false)
          setLevelSelected(response?.data?.difficultylevel)
          if(response?.data?.isLevelSet){
            setisLevelSet(true);
          }
        }
      }
      }).catch((error) => {
        // setError("Only instructor can change settings.");
        setError({"id":"00000","msg":"Only instructor can change settings."})
        console.log(error);
      })
    }
    },1000)
    if (document.querySelector("footer.footer .container") != null) {
        document.querySelector("footer.footer .container").style.justifyContent = "center";
    }
    if (document.querySelector("footer.footer .footer-nav .footer-links li.skip-intro") != null) {
        document.querySelector("footer.footer .footer-nav .footer-links li.skip-intro").style.display = "block";
    }
    if (document.querySelectorAll("footer.footer .footer-nav .footer-links li:not(.skip-intro)").length > 0) {
      document.querySelectorAll("footer.footer .footer-nav .footer-links li:not(.skip-intro)").forEach((item) => {
        item.style.display = "none"
      });
    }
    document.querySelectorAll(".ui.selection.dropdown.cust1 .menu .item").forEach((item) => {
      item.addEventListener("click", (e) => {
        // document.querySelector(".cancelSettings").removeAttribute("disabled");
        setIsLevelUpdated(true);
      })
    });
    document.querySelector(".ui.checkbox").addEventListener("change", (e) => {
        setIsLeaderboardUpdated(true);
    });

    document.querySelector(".cancelSettings").addEventListener("click", (e) => {
      let selectedOption = document.querySelector(".ui.selection.dropdown.cust1 .text").textContent.toUpperCase()
      let isLeaderboard = document.querySelector(".ui.checkbox input").checked;
      save_settings({ 'level': selectedOption, 'leaderboard' : isLeaderboard ? 1 : 0 }).then((response) => {
        // document.querySelector(".cancelSettings").setAttribute("disabled", "true");
        setIsSaveDisable(true);
        setIsLeaderboardUpdated(false);
        setIsLevelUpdated(false);
        if (response?.data?.isLevelSet) {
          setisLevelSet(true);
        }
        setLevelSelected(selectedOption)
      }).catch(() => {

      })
    });

    return () => {
      document.querySelector("header.header .artifacts").style.display = "block";
      if (document.querySelector("footer.footer .container") != null) {
        document.querySelector("footer.footer .container").style.justifyContent = "space-between";
      }
      if (document.querySelector("footer.footer .footer-nav .footer-links li:not(.skip-intro)") != null) {
        document.querySelectorAll("footer.footer .footer-nav .footer-links li:not(.skip-intro)").forEach((item) => {
          item.style.display = "block"
        });
      }
      if (document.querySelector("footer.footer .footer-nav .footer-links li.skip-intro") != null) {
        document.querySelector("footer.footer .footer-nav .footer-links li.skip-intro").style.display = "none";
      }
    }
  }, []);

  useEffect(()=>{
    if(Object.keys(settings).length != 0){
      if(settings?.usercount && Number(settings?.usercount) != 0){
        const focusableElements = document.getElementsByClassName(`${ImModuleStyle["setting"]}`)[0].querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        document.getElementsByClassName(`${ImModuleStyle["setting"]}`)[0].style.pointerEvents = "none"
        // Set tabindex="-1" for each focusable element
        focusableElements.forEach(element => {
          element.setAttribute('tabindex', '-1');
        });
        // document.getElementsByClassName(`${ImModuleStyle["setting"]}`)[0].querySelector('.cancelSettings').setAttribute('disabled', 'true');
        setIsSaveDisable(true);
      }
      document.querySelector(".ui.selection.dropdown.cust1 .text").textContent = settings?.difficultylevel
    }
  },[settings])
  useEffect(()=>{
    if((!isLevelSet && isLevelUpdated) || (isLevelSet && (isLeaderboardUpdated || isLevelUpdated)))
      {
        // document.querySelector(".cancelSettings").removeAttribute("disabled");
          setIsSaveDisable(false);
      }
    },[isLevelSet,isLeaderboardUpdated,isLevelUpdated])
  return (
    <div className={`${ImModuleStyle["setting"]} ${ImModuleStyle["container"]}`} style={settingStyle}>
      <div className={`${ImModuleStyle["content-block"]}`}>
        <div style={{display:"flex"}} className={`${ImModuleStyle["level-dropdown"]}`}>
          <div className={`${ImModuleStyle["title-div"]}`}>
            <div className="dropdown-title" style={{ "marginTop": "10px", "text-align": "right" }}>Difficulty Level</div>
          </div>
          <div>
            <div className="ui selection dropdown cust1">
              <input type="hidden" name="type" />
              <em className="dropdown icon"></em>
              <div className="default text"></div>
              <div className="menu">
                <div className="item" data-value="1">Easy</div>
                <div className="item" data-value="0">Medium</div>
                <div className="item" data-value="2">Hard</div>
              </div>
            </div>
          </div>
        </div>
        <div style={{ display: "flex" }} className={`${ImModuleStyle["leaderboard-radio"]}`}>
          <label className={`${ImModuleStyle["title-div"]}`}>Leader Board</label>
          <div class="ui toggle checkbox">
            <label></label>
            <input type="checkbox" name="public"/>
          </div>
        </div>
        <div className={`${ImModuleStyle["btns-container"]}`}>
          <Button btnName="Cancel" btnWidth="80" customBtnStyle={{marginTop: "15px"}} clickEventHandler={closeWindow} />
          <Button btnName="Save" btnWidth="80" customBtnStyle={{marginTop: "15px"}} btnParentClassName={`${ImModuleStyle.ml10}`} disabled={isSaveDisable} btnClass={"cancelSettings"}/> 
        </div>
      </div>  
      <div class={`ui warning message tiny ${ImModuleStyle["ui"]} ${ImModuleStyle["message"]}`}>
          {
            (settings?.usercount > 0) ? "You can not change the difficulty level as the simulations are started by students." 
            : (!isLevelSet) ? `If you do not set any level, the default difficulty level (${levelSelected}) will be set.`
            : `The difficulty level is set to ${levelSelected}.`
          }
      </div>
      <div style={{marginTop:"20px",marginLeft:"50px"}}>
      <table class="ui celled table" style={{width:"500px"}}>
  <thead>
    <tr><th>Level</th>
    <th>Values</th>
  </tr></thead>
  <tbody>
    {
      settings?.levelData?.map((item)=>{
        return <tr>
        <td data-label="level">{item?.level}{settings?.defaultDefficultyLevel == item?.level ? " (Default)" : ""}</td>
        <td data-label="values">
          {
            item?.data?.map((data,index)=>{
              return <p style={{margin:"5px 0"}}>{data?.key+": "+`${data?.isFormat?"$":''}`+formatNum(data?.value)}</p>
            }) 
          }
        </td>
      </tr>
      })
    }
  </tbody>
</table>
        </div>
    </div>
  )
}

export default Settings